/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MgmtShippingLabelControllerGetLabelFile$Params {
  id: number;
}

export function mgmtShippingLabelControllerGetLabelFile(http: HttpClient, rootUrl: string, params: MgmtShippingLabelControllerGetLabelFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, mgmtShippingLabelControllerGetLabelFile.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

mgmtShippingLabelControllerGetLabelFile.PATH = '/api/mgmt/shipping-label/{id}/label-file';
